module.exports = __webpack_public_path__ + "static/img/video.af59cfef.png";